<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong><i class="cui-graph icons font-2xl mt-4"></i> Master AWB Status Listing  </strong>
            <div class="card-header-actions">                      
            </div>
          </div>  
          <!--  <div id="overlay" >
             <div class="loader"></div>
           </div>  -->
              <div id="printableArea" >
            <div class="page-break" v-for="item in masterawbdataarr" >
              <table>
                  <tr >
                    <td >
                     <div>
                      <table border = '1' class="stickertable"  >
                        <tr>

                          <td>
                          <div style='text-align: center;font-size: 2px;'>
                          <img id='test'/>
                          <div id="app" >
                                  {{item.master_awb}}
                          <barcode v-bind:value="item.master_awb">
                          Show this if the rendering fails.
                          </barcode>
                          </div>
                          </div>
                          </td>
                        </tr>

                      <tr>
                        <td colspan ='2' class="addpad">

                          <span style ='font-size: 35px;  display: block;
  margin-bottom: 8px;'><b>Master AWB : </b> <b>{{item.master_awb}}</b></span> <br>
                         
                        <!--   <span style ='font-size: 30px;  display: block;
  margin-bottom: 8px;'>Country:<b> {{item.country}}</b></span><br>
                          <span style ='font-size: 30px; display: block;
  margin-bottom: 8px;' >Transport_mode:<b>{{item.transport_mode}}</b></span><br> -->
                          <!-- <span style ='font-size: 20px;'>Created_date: {{item.created_date}}</span><br>
                          <span style ='font-size: 20px;'>Created_by: {{item.created_by}}</span><br>
                          <span style ='font-size: 20px;'>Dispatch_date: {{item.dispatch_date}}</span><br>
                          -->
                          <br>
                        </td>
                      </tr>
                     
                     </table>
                   </div>
                    </td>
                  </tr>
                </table>
            </div>           
          </div>
          <div class="box">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
        <!--         <b-col md="6" >  
                  <b-form-group label="AWB Number" :label-cols="3"> 
                   <b-form-input class="input" type="text" name="masterawb" 
                   v-model="customer.masterawb" v-validate="'required'" 
                   :class="{'input': true, 'is-danger': errors.has('form-1.masterawb') }" placeholder="Enter AWB Number ">
                   </b-form-input>
                    <span v-show="errors.has('form-1.masterawb')" class="help text-danger">{{ errors.first('form-1.masterawb') }}</span>
                   </b-form-group>          
                </b-col>  -->
               
              <!--   <b-col md="6" >
                  <b-button type="submit" size="md" class="mr-4" variant="primary"> Search</b-button>
                  <b-button type="button" size="md" variant="danger" @click="clear"> Clear</b-button> 
                               
                </b-col> -->
              </b-row>  
           <!--    <b-row> 
                <b-col md="12" >  
                <b-button style="display: none; float: right; " id="printbutton" variant="primary" size="md" value="print a div!" @click="barcodedata('printableArea')">Print AWB Details</b-button>
              </b-col>
            </b-row> -->
            
            
            </form>
          </div>  
          
         <b-col sm="12" class="text-right">
               <!--  <b-button v-if="this.totalRows >0"  variant="primary" size="md" @click="downloadCSV">Download </b-button>  -->
               <p > <b>Total Records :<span style="color:red;">{{totalRows }}</span></b> </p>
              </b-col> 
                    <div id="printableArea" >
            <div class="page-break" v-for="item in masterawbdata" >
              <table>
                  <tr >
                    <td >
                     <div>
                      <table border = '1' class="stickertable"  >
                        <tr>

                          <td>
                          <div style='text-align: center;font-size: 2px;'>
                          <img id='test'/>
                          <div id="app" >
                                  {{item.master_awb}}
                          <barcode v-bind:value="item.master_awb">
                          Show this if the rendering fails.
                          </barcode>
                          </div>
                          </div>
                          </td>
                        </tr>

                      <tr>
                        <td colspan ='2' class="addpad">

                          <span style ='font-size: 35px;  display: block;
  margin-bottom: 8px;'><b>{{item.master_awb}}</b></span> <br>
                         
                         <!--  <span style ='font-size: 30px;  display: block;
  margin-bottom: 8px;'>Country:<b> {{item.country}}</b></span><br> -->
                         <!--  <span style ='font-size: 30px; display: block;
  margin-bottom: 8px;' >Transport_mode:<b>{{item.transport_mode}}</b></span><br> -->
                          <!-- <span style ='font-size: 20px;'>Created_date: {{item.created_date}}</span><br>
                          <span style ='font-size: 20px;'>Created_by: {{item.created_by}}</span><br>
                          <span style ='font-size: 20px;'>Dispatch_date: {{item.dispatch_date}}</span><br>
                          -->
                          <br>
                        </td>
                      </tr>
                     
                     </table>
                   </div>
                    </td>
                  </tr>
                </table>
            </div>           
          </div>
            <b-col sm="12" >
            <b-table show-empty stacked="md" style="table-layout: fixed"  :busy="isBusy" :current-page="currentPage" :per-page="perPage" :items="masterawbdata" :bordered="bordered" :fields="fields"   :outlined="outlined"  >

             
              <template slot="istatus" slot-scope="row">
                
              <!--   <span>{{ (row.item.status==0)?'Created':'Dispatch'}} </span>  -->
              {{row.item.status}}
                
                </template>
                <template slot="actions" slot-scope="row">
              <!-- style="position: absolute;right: 90px;margin-top: 4px;" position: absolute;right: 17px; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-->
             <input @change="setStickerHTMl($event,row.item)" type="radio" name="radAnswer" v-model="row.item.selected" class="awbcheckbox" id="stiker" :checked="checkedData" >
             &nbsp;&nbsp;&nbsp;
                <b-button  v-if="!row.item.Dispatch" id="printbutton" variant="primary" size="sm" value="print a div!" @click="barcodedata('printableArea',row.item)" style="font-size:10px;background: #b0c4de !important;
    color: #000 !important;">Print Details</b-button>  
                 <br>
                  <!-- <br> -->
                  <b-button size="sm" @click="showinfoModal(row.item)" class="mr-1" data-toggle="tooltip" title="Master AWB Shipment"
                   style="font-size:10px; margin-left: 12%;
    margin-top: 5%;background: #b0c4de !important;
    color: #000 !important;">
                    View Shipment
                  </b-button>
                 <!-- <b-button    id="printbutton" variant="primary" size="sm" value="print a div!" @click="barcodedata('printableArea')" style="background: #b0c4de !important;color: #000 !important;">Print Zone </b-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
             
          
             <!-- {{row.item.master_awb}} -->
<!--                    <b-button size="sm" @click="showinfoModal(row.item)" class="mr-1" data-toggle="tooltip" title="Master AWB Shipment"
                   style="position: absolute;font-size:10px;padding-left:8px;padding-right:8px;background: #b0c4de !important;margin-left:-4px;
    color: #000 !important;">
                    View Shipment
                  </b-button>
                  <br>
                  <br>
                   <b-button size="sm" @click="shipmentlogModal(row.item)" class="mr-1" data-toggle="tooltip" title="Master AWB Shipment Log"
                   style="position: absolute;font-size:10px;padding-left:8px;padding-right:8px;background: #b0c4de !important;margin-left:-4px;
    color: #000 !important;">
                  Shipment Log
                  </b-button>
                   <br>
                  <br> -->
                 <!--   <router-link
        to="/masterawbdetails"
      > <b-button size="sm" class="mr-1" style="padding-left: 20px;
    padding-right: 20px;
    margin-left: 2px;">
                    View Details
                  </b-button> </router-link>  -->
                <!--  <router-link :to="{ name: 'masterawbdetails', params: { id: row.item.master_awb } }" style="text-decoration: none;
    color: black;
    font-size: 12px;
    border: 0.5px solid #b0c4de;
    padding: 5px;
        margin-left: -4px;
    background-color: #b0c4de !important;
    border-radius: 4px;" data-toggle="tooltip" title="Master AWB Details">
                   Details
                 </router-link> -->

                  <!-- <b-button size="sm" @click="showdimensionInfo(row.item)" style="margin-left:4px;background: #b0c4de !important;
    color: #000 !important;" class="mr-1"
                   data-toggle="tooltip" title="Edit Box Dimensions"
                   >
                   <i class="fa fa-pencil-square" aria-hidden="true"></i>
                  </b-button>
 -->              
                </template>

                
             
               
                

              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>           
            </b-table>
          </b-col>
           <b-modal size="lg" title="MAWB Shipment Log" v-model="shipmentlog" >
               <b-row>
            <b-col sm="12" class="text-right " >
                <b-button type="submit" variant="primary" size="md" @click="downloadCSV">Download </b-button>

              </b-col>

          </b-row>
            <div id="overlay" >
             <div class="loader"></div>
           </div> 
            <b-row>
              <b-col sm="12" class="text-right">
               <!--  <b-button v-if="this.totalRows >0"  variant="primary" size="md" @click="downloadCSV">Download </b-button>  -->
               <p > <b>Total Records :<span style="color:red;">{{total_row_logshipment }}</span></b> </p>
              </b-col> 
          </b-row>
           <!-- -->
    
          <div class="table-responsive-sm" v-for="(value, firstIndex) in logawblist">
                          <table class="table table-striped table-bordered" border="1" >
                      <thead  v-if="firstIndex ===0">
                        <tr>
                         <th>Shipping ID</th>
                          <th>AWB Title</th>
                          <th>Country Code</th>
                          <th>Mode Of Transport</th>
                          <th>Status</th>
                        
                           
                        </tr>
                      </thead>
                      <tbody v-if="firstIndex ===0">
                        
                        <tr v-for="log in shipmentloglist">
                          <td>{{log}}</td> 
                          <td>{{value.master_awb }}</td>
                          <td>{{value.country}}</td>
                          <td>{{value.transport_mode }}</td>
                           <td>{{value.status }}</td>
                        
                        </tr>
                      </tbody>
                    </table>
                  </div>
           </b-modal>

                <b-modal size="lg" title="MAWB Shipment List" v-model="editAgentMaster" @ok="editAgentMaster = false" hide-footer>

          <b-row>
              <b-col sm="12" class="text-right">
              
               <p > <b>Total Records :<span style="color:red;">{{total_row_shipment }}</span></b> </p>
              </b-col> 
          </b-row>

        
          <b-table show-empty stacked="md"  :items="shipmentawblist" :busy="isBusyshipment"  :fields="fields1" :current-page="shipcurrentPage" :per-page="shipperPage" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>  
            

        
          </b-table>
          <b-col md="12" class="my-1 " v-if="total_row_shipment>10">
            <b-pagination
                v-model="shipcurrentPage"
                :total-rows="total_row_shipment"
                :per-page="shipperPage"
                class="my-0"
              ></b-pagination>
          </b-col> 
       
      </b-modal> 
             <b-col md="12" class="my-1 " v-if="totalRows > 10">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col> 
              
<!--             
<table style="width:100%">
  
  <tr v-if="shippingidsdata.length >0">
    <th colspan="5">Shipping ID's :</th>
    
  </tr>

  <tr v-for="(item, index) in shippingidsdata">

    <td >{{ item.shippingid}}
    <br>

    </td>
     

</tr>
 
</table> -->
<div >
  <b-row > 
     <b-col md="12" >
   <!--    float: right; -->
  <b-button style="display: none; margin-bottom:2% " id="deletebutton" variant="primary" size="md" value="print a div!" @click="deleteshippingids(shippingidsdata)">Remove Shipping-Id</b-button>
</b-col>
</b-row>
</div>
    <div class="row" >
    
      <div class="col-md-2" style="margin-bottom:2%" v-for="(item, index) in shippingidsdata">
       
          <input type="checkbox" name="shippingid"   
          v-if="status =='Created'" @change="deleteshippment($event)"  v-model="checkedShipmentID"  v-bind:value="item.shippingid">
        {{ item.shippingid}}

      </div>
    </div>
    
 
        </b-card>
      </b-col>
    </b-row>      
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import VueBarcode from 'vue-barcode';
export default {
  data: function () {
    return {
      isBusy: false,
      customer: {},
      dimensions:{
        length:null,
        width:null,
        height:null,
      },
      selected_master_awb:'',
      // dimensions_length:0,
      // dimensions_width:0,
      // dimensions_height:0,
      outlined:true,
      bordered: true,
      checkedData: false,
       currentPage: 1,
       modelcurrentPage:1,
       modelperPage:10,
         sortDesc: false,
        allowCustomValue : true,
        sortDirection: 'desc',
        filter: null,
        sortBy: null,
      data: [],
      totalRows: 0,
      shipperPage:10,
      shipcurrentPage:1,
      logcurrentPage:1,
      logperPage:1,
      total_row_shipment:0,
      perPage:  10,
      masterawbdataarr:[],
      pageOptions: [5, 10, 15],
      items: [],
      item:[],
      status:'',
      shipmentlist:[],
      customurl:'',
      // detailsshipmentlist:[],
       temp_list:[],
      awblist:[],
      shipmentloglist:[],
      logawblist:[],
      awbDimension:false,
      shipmentlog:false,
      editAgentMaster:false,
      selected_masterawb:'',
      selected_status:'',
        shippingidsdata: [],
        master:'',
      fields: [
      {key: 'deliveryagentname', label: 'Rider Name'},
      {key: 'master_awb', label: 'Master AWB'},
      // {key: 'country',label:' For Country'},
      // {key: 'transport_mode', label: 'Transfer Mode'},
      {key: 'istatus', label: 'Status'},
      {key: 'created_date', label: 'Created Date'},
      {key: 'created_by', label: 'Created By'},
      {key: 'updated_date', label: 'Dispatch Date'},
      // {key: 'dimensions_length', label: 'Box Length'},
      // {key: 'dimensions_width', label: 'Box Breadth'},
      // {key: 'dimensions_height', label: 'Box Height'},
      { key: 'actions', label: 'Actions' ,tdClass: 'nameOfTheClass1'}],
     shipmentawblist:[], 
     isBusyshipment:false,
   fields1: [
          { key: 'shipmentId', label: 'Shipping Id', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'masterAwb', label: 'Master AWB', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'shipmentstatus', label: 'Shipment Status', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'deliverystatus', label: 'Delivery Status', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
       ], 
       logfields: [
          { key: 'shipping', label: 'Shipping Id', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'master_awb', label: 'AWB Title', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'country', label: 'Country Code', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'transport_mode', label: 'Mode Of Transport', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
         { key: 'status', label: 'Status', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
         // { key: 'actions', label: 'Custom Invoice'}
       ], 

     shippingidsFields:[{key:'shippingids' , label:'Shipping ID' }],
      checkedShipmentID:[],
      masterawbdata: [],
      isConsignmentActivityTrackingGetWeb: 0,
      isConsignmentMasterGetStatus: 0,
      isGetlogisticlogdetails: 0,
      selected_master_awb:'',

    }
  },
   components: {
    'barcode': VueBarcode
  },
  created: function () {
    this.getmasterawblisting();
  },
  methods: {
    //function for listing
    getmasterawblisting:function() {
        var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.isBusy = true;
    const Obj_listing = {
            hub_id:`${userInfo.pickuplocationmasterid}`,
                }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getMasterawbListForKsa`,Obj_listing)
            .then((result) => {
           
           // console.log( result.body);
             this.isBusy = false;
              if (result.body.returnmsg =="Successful") {
                 // document.getElementById("overlay").style.display = "none";
                this.masterawbdata = result.body.returnvalue
                  this.shippingidsdata = result.body.shipment
                  this.status=result.body.returnvalue[0].status
                 this.totalRows = result.body.returnvalue.length;
                 
                // this.isBusy = false;
              
              } 
              else {
                //alert('Result not found')
                this.masterawbdata = []
                this.shippingidsdata = []
                

              
                // this.isBusy = false;
                  
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })
      
    },
         setStickerHTMl(e,value){
          this.selected_master_awb=value.master_awb;
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
           this.masterawbdataarr=[];
          // alert("i m in setstiker")
          // alert(this.checkedData);
      // this.qrvalue="";
         this.checkedData=true;
    
 const obj = {

        master_awb:value.master_awb,
        country:value.country,
        transport_mode:value.transport_mode,

         hub_id:`${userInfo.pickuplocationmasterid}`,
       

      }

           this.masterawbdataarr.push(obj);


           

            // this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmasterawbdetails`,obj)
            // .then(result => {

              // this.masterawbdataarr = result.body.returnvalue;
               // this.qrvalue=result.body.returnvalue[0].pallet_id;
               
              
             // var qr =""+this.qrvalue;
              // alert(qr);

               // this.valuess=qr.trim();;
              //alert(this.valuess);

              // console.log(this.qrvalue)

            // })
            // .catch(ex => {
            //   console.log('error-----', ex)
            // });



    
    },
   
    shipmentlogModal:function(value){
            // alert(value.status);
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      // alert(value.pallet_id);
      //alert(" i m in info model");
      this.selected_status=value.status;
      this.selected_masterawb=value.master_awb;
      var Obj = {
          // pallet_id : value.pallet_id,
         // linehaulpallet_id: value.pallet_id,
        master_awb:value.master_awb,
        hub_id:`${userInfo.pickuplocationmasterid}`, 
      };  
       
  
// getshipmentlistfromlinehaulpallet

         this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmasterawbdetails`,Obj)
        .then((result) => {
          // console.log(result);
          if (result.body.returnmsg === 'Successful') {
            
          this.shipmentloglist = result.body.returnvalue.master_awb_details[0].shipment_list;
           console.log('pallet',this.shipmentloglist);
          
              this.logawblist=result.body.returnvalue.master_awb_details;

              // console.log("awblistttt",this.logawblist);
            
              this.total_row_logshipment=result.body.returnvalue.shipment_count;
              this.shipmentlog = true;
          } 
          else {
          this.logawblist=result.body.returnvalue;
          this.shipmentlog = true;
           this.shipmentloglist=[]; 
           this.total_row_logshipment=0; 
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })  
    },
    showinfoModal: function(value) {
      // alert(value);
      console.log("Master",value);
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.editAgentMaster = true;
      this.isBusyshipment=true;
      // this.selected_status=value.status;
      // this.selected_masterawb=value.master_awb;
      var Obj = {
          
        master_awb:value.master_awb,
        // hub_id:`${userInfo.pickuplocationmasterid}`, 
      };  
       console.log("TYYY",Obj);
  

         this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getShipmentlistOfMasterawbForKsa`,Obj)
        .then((result) => {
          console.log(result);
          this.isBusyshipment=false;
          if (result.body.returnmsg === 'Successful') {
            
          this.shipmentawblist=result.body.returnvalue;
          this.total_row_shipment=result.body.returnvalue.length;
              
          } 
          else {
          this.shipmentawblist=[];
          this.total_row_shipment=0;
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })   
    },

 // Download CSV


downloadCSV: function() {
   document.getElementById("overlay").style.display = "block";
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata) 
 // alert(" i m i  Download");
 // alert(pagee);
 
      
          var csvObj = {
          
          sysusermasterid:`${userInfo.sysusermasterid}`, 
          hub_id:`${userInfo.pickuplocationmasterid}`, 
          master_awb:this.selected_masterawb,
            
           
          };
         
         
      

      // console.log(csvObj);
     
      
//         var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// console.log(queryString);
     
      //var r = Math.random().toString(36).substring(3);
this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getMasterawbShipmentListcsv`,csvObj)
        .then(result => {
         // console.log(result);
          document.getElementById("overlay").style.display = "none";
          if(result.body=="success")
         {
         alert("Please Check Your Mail For Downlod Link")
          // this.$fire({
          //         text:"Please Check Your Mail For Downlod Link",
          //         type: "success",
          //         timer: 30000
          //       }); 
       }
       else
       {
        alert("Can not Download");
          // this.$fire({
          //         text:"Can not Download",
          //         type: "error",
          //         timer: 30000
          //       }); 
       }
        //window.location.href =result.url;
        });
        
    },






      barcodedata(printableArea,value){
  //alert(this.checkedData);
//this.checkedData=true;
if(this.checkedData==true && this.selected_master_awb==value.master_awb)
{

     var printContents = document.getElementById("printableArea").innerHTML;


    var disp_setting="toolbar=yes,location=no,";
    disp_setting+="directories=yes,menubar=yes,";
    disp_setting+="scrollbars=yes,width=650, height=600, left=100, top=25";
       var content_vlue = printContents;
       var docprint=window.open("","",disp_setting);
       docprint.document.open();
       docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
      docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
      docprint.document.write('<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">');
      docprint.document.write('<head>');
      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write('font-family:verdana,Arial;color:#000;');
      docprint.document.write('font-family:Verdana, Geneva, sans-serif; font-size:20px;}');
      docprint.document.write('a{color:#000;text-decoration:none;} ');
      docprint.document.write('.stickertable{ border-collapse: collapse;margin-bottom: 20px; width:540px;height:540px} ');
      docprint.document.write('.printarea{ font-size: 30px;text-align: center;}');

      docprint.document.write('.addpad{ padding: 10px; }');


       docprint.document.write('@media all { .page-break { display: block;vertical-align: middle;margin-top:20px; }}');

docprint.document.write('@media print { .page-break { display: block; page-break-before: always; }}  @page { size: auto;  margin: 0mm; }');        


        docprint.document.write('.stickertable td{ padding-bottom:10px;  }');

        docprint.document.write('@page { size: 101.6mm 152.4mm;}</style>');


        //docprint.document.write('@media print { td.page-break  { display: block; page-break-before: always; } } </style>');  


  

       docprint.document.write('</head><body onLoad="self.print()"><center>');



       
       docprint.document.write(content_vlue);
docprint.document.write('</center></body></html>');
           docprint.document.close();

}
else
{
  alert("Please Select Radion Button");
   // this.$fire({
   //                text:"Please Select Radion Button",
   //                type: "warning",
   //                timer: 30000
   //              }); 
}
    },
   


        
    clear: function() {
      this.customer = {}
      this.errors.clear('form-1')
       document.getElementById("printbutton").style.display ="none";
          this.masterawbdata = []
          this.shippingidsdata = []
           document.getElementById("deletebutton").style.display ="none";
      
    }
  },

  filters: {
    datechange: function (value) {
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+'  '+ " " + strTime;

      }
    }
  }
};
</script>
<style>
  .b-table-caption-top{
    color: black;
  }
  .shipping table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}
th, td {
  padding: 5px;
  text-align: left;    
}

  .nameOfTheClass1 {
  width:260px ;
  white-space: nowrap;
   
}
#overlay1 {
  position: fixed; /* Sit on top of the page content */
  /*display: none;*/ /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 9999; /* Specify a stack order in case you using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader1 {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 50px;
  height: 50px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  /*display: none;*/ /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 9999; /* Specify a stack order in case you using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 50px;
  height: 50px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}
</style>
